import {createInsertSchema, createSelectSchema, createUpdateSchema} from 'drizzle-zod';
import * as schema from './schema';

export const DB_SCHEMAS = {
  createSource: createInsertSchema(schema.sources),
  selectSource: createSelectSchema(schema.sources),
  updateSource: createUpdateSchema(schema.sources),
  selectDocument: createSelectSchema(schema.documents),
  createKnowledgeBase: createInsertSchema(schema.knowledgeBases),
  updateKnowledgeBase: createUpdateSchema(schema.knowledgeBases),
  selectKnowledgeBase: createSelectSchema(schema.knowledgeBases),
  createTenant: createInsertSchema(schema.tenants),
  selectTenant: createSelectSchema(schema.tenants),
  updateTenant: createUpdateSchema(schema.tenants),
  createRole: createInsertSchema(schema.roles),
  selectRole: createSelectSchema(schema.roles),
  updateRole: createUpdateSchema(schema.roles),
  createChatConversation: createInsertSchema(schema.chatConversations),
  selectChatConversation: createSelectSchema(schema.chatConversations),
  updateChatConversation: createUpdateSchema(schema.chatConversations),
  createUser: createInsertSchema(schema.users),
  selectUser: createSelectSchema(schema.users),
  updateUser: createUpdateSchema(schema.users),
  selectRoleType: createSelectSchema(schema.roleTypes),
  selectInvite: createSelectSchema(schema.invites),
  createAssistant: createInsertSchema(schema.assistants),
  selectAssistant: createSelectSchema(schema.assistants),
  updateAssistant: createUpdateSchema(schema.assistants),
  createAssistantKnowledgeBase: createInsertSchema(schema.assistantKnowledgeBases),
  selectAssistantKnowledgeBase: createSelectSchema(schema.assistantKnowledgeBases),
  createAppConfig: createInsertSchema(schema.appConfigs),
  selectAppConfig: createSelectSchema(schema.appConfigs),
  updateAppConfig: createUpdateSchema(schema.appConfigs),
  createTokenUsage: createInsertSchema(schema.tokenUsage),
  selectTokenUsage: createSelectSchema(schema.tokenUsage),
  createChatMessage: createInsertSchema(schema.chatMessages),
  selectChatMessage: createSelectSchema(schema.chatMessages),
  createChatAttachment: createInsertSchema(schema.chatAttachments),
  selectChatAttachment: createSelectSchema(schema.chatAttachments),
  createTenantMcpServer: createInsertSchema(schema.tenantMcpServers),
  selectTenantMcpServer: createSelectSchema(schema.tenantMcpServers),
  updateTenantMcpServer: createUpdateSchema(schema.tenantMcpServers)
};
